import { useEffect } from 'react';
import { useNotification } from '@/context/notificationProvider';
import { RECENTLY_REMOVED } from '../../../../constants/constant';

interface Notification {
  classname?: string;
  message?: any;
  textColor?: string;
  color?: string;
  icon?: any;
  showUndoButton?: boolean;
  undoFunction?: () => void;
  setNotificationMessage?: any;
  notificationMessage?: any;
  closeFlag?: any;
  iconClass?: string;
  isError: boolean;
  setShowUndoButton?: (value: boolean) => void;
  clearNotification?: boolean;
  seeSimilarItems?: boolean;
  isScrolltoTop?: boolean;
}

const Notification: React.FC<Notification> = ({
  classname,
  message,
  textColor,
  color,
  icon,
  showUndoButton,
  undoFunction,
  setNotificationMessage,
  notificationMessage,
  isError = false,
  iconClass,
  closeFlag,
}) => {
  const { showNotification } = useNotification();

  const handleClose = () => {
    if (setNotificationMessage) {
      setNotificationMessage('');
      showNotification('');
      localStorage.removeItem(RECENTLY_REMOVED);
    }
  };

  useEffect(() => {
    const notificationTimeout = setTimeout(() => {
      handleClose();
    }, 10000);
    return () => clearTimeout(notificationTimeout);
  }, [notificationMessage, showNotification]);

  return (
    <section
      className={`${
        isError ? 'sessioncamlogerror' : ''
      } flex w-auto items-center justify-between gap-x-2 ${color} rounded-md px-2 py-1 pl-1 ${classname}`}
    >
      <section className="flex items-start gap-x-2">
        <section className={iconClass}>{icon}</section>
        <section>
          <p className={`${textColor} font-medium leading-6`}>{message}</p>
        </section>
      </section>
      <section className="flex justify-evenly gap-x-2">
        {showUndoButton && (
          <button
            type="button"
            className="rounded border bg-white px-3 py-1 pr-2 font-medium leading-6 text-black underline hover:bg-green-300"
            onClick={() => {
              if (undoFunction) {
                undoFunction();
                handleClose();
              }
            }}
          >
            Undo
          </button>
        )}
        {closeFlag && (
          <button type="button" className="mx-2 text-black" onClick={handleClose}>
            &#x2715;
          </button>
        )}
      </section>
    </section>
  );
};

export default Notification;
